export default __webpack_public_path__ + "static/media/Mantle of Valka's Wrath.12284849.jpg";